import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  cadastroMarcaInRequest,
  deleteCadastroMarca,
  findCadastroMarca,
  recordFiltering,
} from '~/store/modules/cadastromarca/actions';

import CadastroMarcaForm from './form';

function CadastroMarca() {
  const cadastromarca = useSelector((state) => state.cadastromarca);

  const header = useMemo(
    () => [
      {
        id: 'vemm_codigo',
        label: 'Código:',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'vemm_nome',
        label: 'Nome',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="vemm_codigo ASC"
        fixed
        create={false}
        delete={false}
        update={false}
        header={header}
        redux={cadastromarca}
        //custom={filter}
        //actions={buttons}
        keys={['vemm_codigo']}
        detach="vemm_codigo"
        read={recordFiltering}
        find={findCadastroMarca}
        //remove={deleteCadastroMarca}
        form={CadastroMarcaForm}
        view="VW_TB_VEICULO_MARCA_MODELO_SGTA"
        reportTitle="Cadastro de Marca"
      />
      {/* <Tabela
        read={cadastroMarcaInRequest}
        remove={deleteCadastroMarca}
        state={cadastromarca}
        header={header}
        noCreate
        noEdition
        headerMobile="vemm_codigo"
        unique={['vemm_codigo']}
        form={CadastroMarcaForm}
        findItem={findCadastroMarca}
        recordFilter={recordFiltering}        
      /> */}
    </>
  );
}

export default CadastroMarca;
